import React from "react";
import styled from "styled-components";
import Singles from "../components/singles.js";
import Caution from "../assets/CAUTION.png";

const Hero = styled.div`
  background-color: black;
  display: flex;
  height: 75vh;

  @media screen and (max-width: 900px) {
    flex-direction: column;
    height: auto;
  }
`;

const HeroContent = styled.div`
  margin: 25vh auto;
  min-height: 50%;
  text-align: center;
  max-width: 800px;
  flex: 1 1 auto;

  @media screen and (max-width: 900px) {
    min-height: 0;
    margin: 6vh 6vw;
  }
`;

const HeroImage = styled.a`
  overflow: hidden;
  width: auto;
  min-width: 360px;
  height: 100%;

  @media screen and (max-width: 900px) {
    flex: 1;
    padding: 0;
    margin: 0 auto 0 auto;
    min-width: 0;
    height: 400px;
    width: auto;
  }
`;

const AlbumCover = styled.img`
  height: 100%;
  width: auto;
`;

const Title = styled.h1`
  color: #ffc30b;
  font-size: 58px;

  @media screen and (max-width: 900px) { 
    font-size: 42px;
  }
`;

const Subtitle = styled.p`
  color: #686868;
  font-size: 30px;
`;

const CautionBanner = styled.div`
  border: 2px solid black;
  background: repeating-linear-gradient(
    45deg,
    #ebd007,
    #ffc30b 30px,
    #555 30px,
    #555 60px
  );
  height: 40px;
  max-width: 100%;
  width: 100vw;

  @media screen and (max-width: 900px) { 
    height: 24px;
  }
`;

export default ({ data }) => (
  <div>
    <Hero>
      <HeroContent>
        <Title>CAUTION</Title>
        <Subtitle>Now streaming on all platforms</Subtitle>
      </HeroContent>
      <HeroImage
        target="_blank"
        href="https://open.spotify.com/album/7cX3H9PyXY0ObG7qvRw14L"
      >
        <AlbumCover src={Caution} />
      </HeroImage>
    </Hero>
    <CautionBanner />
    <Singles />
    <Hero>
      <HeroContent>
        <Title>New single and video "IDK" feat. Sincerely Collins</Title>
        <Subtitle>June 2020</Subtitle>
      </HeroContent>
    </Hero>
    <CautionBanner />
    <Hero>
      <HeroContent>
        <Title>Antisocial Extrovert</Title>
        <Subtitle>Dropping soon</Subtitle>
      </HeroContent>
    </Hero>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/index.js